import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/axios.js';

export function useUsuarios() {
  return useQuery({
    queryKey: ['usuarios'],
    queryFn: () => api.get('/usuarios').then((r) => r.data),
  });
}

export function useVendedores() {
  const { data = [] } = useUsuarios();
  return data.filter((u) => u.rol === 'vendedor' && u.activo);
}

export function useCreateUsuario() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post('/usuarios', data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['usuarios'] }),
  });
}

export function useUpdateUsuario(id) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.patch(`/usuarios/${id}`, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['usuarios'] }),
  });
}

export function useToggleActivo(id) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.patch(`/usuarios/${id}/activo`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['usuarios'] }),
  });
}

export function useResetPassword(id) {
  return useMutation({
    mutationFn: (password) => api.patch(`/usuarios/${id}/password`, { password }).then((r) => r.data),
  });
}

export function useCambiarPassword() {
  return useMutation({
    mutationFn: (data) => api.patch('/auth/me/password', data).then((r) => r.data),
  });
}
